<template>
  <MainLayout><slot /></MainLayout>
</template>
